import { REHYDRATE } from 'redux-persist';
import {
  COUNTRY_LIST_FETCH_BEGIN,
  COUNTRY_LIST_FETCH_SUCCESS,
  COUNTRY_LIST_FETCH_FAIL,
} from 'actions/countryActions';

const INITIAL_STATE = { countryList: { loading: false, data: [], error: null } };

export default function countryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case COUNTRY_LIST_FETCH_BEGIN:
      return { ...state, countryList: { ...INITIAL_STATE.countryList, loading: true } };

    case COUNTRY_LIST_FETCH_SUCCESS:
      return { ...state, countryList: { ...INITIAL_STATE.countryList, data: action.payload } };

    case COUNTRY_LIST_FETCH_FAIL:
      return { ...state, countryList: { ...INITIAL_STATE.countryList, error: action.payload } };

    default:
      return state;
  }
}
